import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { useHistory } from 'react-router-dom'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'
import { useAnalyticsClient } from '@acorns/web-utils'

import {
  TITLE_BAR_CLOSE_BUTTON,
  TITLE_BAR_MOBILE_CLOSE_BUTTON,
  TITLE_BAR_SHARE_BUTTON,
} from 'utils/testing/testIDs'

import { ACTIONS, baseAnalyticsOptions } from '../analytics/constants'
import { NavBar } from '../shared/styled-components'
import { RECAP_XS_BREAKPOINT } from '../styles'
import {
  BackButton,
  Content,
  ShareButton,
  ShareButtonText,
  StyledCloseIcon,
  Title,
  TitleBarItem,
} from './styled-components'

const TitleBar = ({
  beneficiaryName,
  beneficiaryId,
  onShowShareModal,
}: {
  beneficiaryId: string
  beneficiaryName: string
  onShowShareModal: () => void
}): React.ReactElement => {
  const analytics = useAnalyticsClient()
  const { getRemoteString } = useRemoteStrings()
  const history = useHistory()

  const isMobile = useMediaQuery({
    query: `(max-width: ${RECAP_XS_BREAKPOINT}px)`,
  })

  const handleBack = () => {
    analytics.track(ACTIONS.BUTTON_TAPPED, {
      ...baseAnalyticsOptions,
      action: 'Tapped',
      beneficiaryId,
      event_description: 'Early Quarterly Recaps Dismiss Tapped',
      object: 'Button',
      object_name: 'earlyQuarterlyRecapDismiss',
    })

    history.push(`/early/details/${beneficiaryId}`)
  }
  return (
    <NavBar>
      <Content>
        <TitleBarItem>
          {isMobile ? (
            <StyledCloseIcon
              data-testid={TITLE_BAR_MOBILE_CLOSE_BUTTON}
              icon={AcornsIcon.Icon.CloseXIconWhite}
              onClick={handleBack}
              width={16}
            />
          ) : (
            <BackButton
              onClick={handleBack}
              data-testid={TITLE_BAR_CLOSE_BUTTON}
            >
              <AcornsIcon icon={AcornsIcon.Icon.CloseXIconWhite} width={14} />
            </BackButton>
          )}
        </TitleBarItem>
        <TitleBarItem>
          <Title>
            {getRemoteString({
              key: 'early.recap.title.variable',
              variables: [beneficiaryName],
            })}
          </Title>
        </TitleBarItem>
        {!isMobile ? (
          <TitleBarItem>
            <ShareButton
              onPress={onShowShareModal}
              data-testid={TITLE_BAR_SHARE_BUTTON}
              styleType="light"
              secondary
            >
              <AcornsIcon icon={AcornsIcon.Icon.UtilityShareIosFv} width={24} />
              <ShareButtonText>
                {getRemoteString({
                  key: 'early.recap.potential.cta',
                })}
              </ShareButtonText>
            </ShareButton>
          </TitleBarItem>
        ) : null}
      </Content>
    </NavBar>
  )
}

export { TitleBar }
